import React, { useEffect, useRef, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { constants } from '../../../config';
import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';

// Establece el token de acceso de Mapbox
mapboxgl.accessToken = constants.REACT_APP_MAPBOX;

const MapSimple = ({ title, latitude: propLatitude, longitude: propLongitude, zoom, markerInfo }) => {
    const mapContainer = useRef(null);

    const selectLayoutState = (state) => state.Layout;
    const selectLayoutProperties = createSelector(
        selectLayoutState,
        (layout) => ({ layoutModeType: layout.layoutModeType })
    );
    const { layoutModeType } = useSelector(selectLayoutProperties);

    const mapStyle = layoutModeType === 'dark'
        ? 'mapbox://styles/mapbox/dark-v10'
        : 'mapbox://styles/mapbox/light-v11';

    const [location, setLocation] = useState({
        loaded: false,
        coordinates: { lat: "", lng: "" },
    });

    const onSuccess = location => {
        setLocation({
            loaded: true,
            coordinates: {
                lat: location.coords.latitude,
                lng: location.coords.longitude,
            },
        });
    };

    const onError = error => {
        setLocation({
            loaded: true,
            error,
        });
    };


    useEffect(() => {
        if (!("geolocation" in navigator)) {
            setLocation(prevState => ({
                ...prevState,
                loaded: true,
                error: { code: 0, message: "Geolocation not supported" }
            }));
            return;
        }

        navigator.geolocation.getCurrentPosition(onSuccess, onError);
    }, []);

    useEffect(() => {
        if (!location.loaded) return;

        const hasCoordinates = propLatitude && propLongitude;
        // const hasLocation = location.coordinates.lat && location.coordinates.lng;
        const hasLocation = null;

        // Use provided props if available, otherwise fall back to geolocation
        const latitude = hasCoordinates ? propLatitude : (hasLocation ? location.coordinates.lat : null);
        const longitude = hasCoordinates ? propLongitude : (hasLocation ? location.coordinates.lng : null);

        if (latitude === null || longitude === null) return; // Exit if no valid coordinates are available

        const map = new mapboxgl.Map({
            container: mapContainer.current,
            style: mapStyle,
            center: [longitude, latitude],
            zoom: zoom,
        });

        // Create a new marker
        const marker = new mapboxgl.Marker()
            .setLngLat([longitude, latitude])
            .addTo(map);

        const popup = new mapboxgl.Popup({ offset: 25 })
            .setText(markerInfo);

        marker.setPopup(popup);

        return () => map.remove();
    }, [location, propLatitude, propLongitude, zoom, mapStyle, markerInfo]);

    return (
        <Card className='p-0 mb-10'>
            {title ? (
                <CardHeader className='p-2'>
                    <h5 className="card-title mb-0">
                        <i className={`${Icons.pin} align-middle me-1 text-muted`}></i>{title}
                    </h5>
                </CardHeader>
            ) : ('')}
            <CardBody className='m-0 p-2'>
                <div ref={mapContainer} style={{ width: '100%', minHeight: '400px' }}></div>
            </CardBody>
        </Card>
    );
};

export default MapSimple;
